module.exports = __webpack_public_path__ + "616d88874071b77a2c87926842f83976.png";